/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 12/20/2024
 */
import React, { useState, useEffect } from "react"
import Select from "react-select"
import api from "../../../base/services/ResApi"
import { FormControl } from "@mui/material"

const TerminalModelsDropdown = ({ onChange, isRequired }) => {
  const [data, setData] = useState([])

  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: "10px",
    }),
  }

  useEffect(() => {
    const config = {
      headers: {
        Action: "ALL_MODELS",
      },
    }
    api
      .get("/terminal/models", config)
      .then((res) => {
        setData(res.data?.dataList)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  const options = data.map((item) => ({
    value: item.model,
    label: item.model,
    target: { name: "model", value: item.model },
  }))

  return (
    <div>
      <p
        style={{
          fontSize: "12px",
          position: "relative",
          top: "-9px",
          left: "10px",
          background: "#fff",
          width: "130px",
          paddingLeft: "5px",
          zIndex: 91,
        }}
      >
        Select Model
      </p>
      <FormControl
        required={isRequired}
        sx={{
          minWidth: 400,
          zIndex: 90,
          position: "relative",
          top: "-32px",
          height: 0,
        }}
        size="medium"
      >
        <Select
          required={isRequired}
          options={options}
          onChange={onChange}
          isClearable
          styles={{
            ...customStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // Ensure it appears above other elements
            }),
          }}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </FormControl>
    </div>
  )
}

export default TerminalModelsDropdown
